import Mutations from '../../odata/mutations';

export default { ...new Mutations('playBookModule'), ...new Mutations('playBookModules') };
